import { useUnit } from 'effector-react';
import { $initialCurrenciesAvailableStore } from '@lib/store';
import type { IntegrationType } from '@shared/api/rest/integrations';
import { Select, Text } from '@shared/widgets';

interface IIntegrationTitleProps {
  name: IntegrationType;
  currency?: string;
  onChangeCurrency: (currency: string | undefined) => void;
}

export const IntegrationTitle = (props: IIntegrationTitleProps) => {
  const currenciesAvailableStore = useUnit($initialCurrenciesAvailableStore.store);

  return (
    <div className='flex items-center justify-between mb-6'>
      <div className='flex items-center'>
        <img className='w-10 h-10 mr-4' src='/images/tmp/xero-logo.svg' alt='Xero' />
        <Text className='grow-1' size='2xl'>
          {props.name} integration
        </Text>
      </div>
      <div className='w-fit'>
        <Select
          className='min-w-[160px]'
          items={currenciesAvailableStore.data}
          nullValue={{ isEnable: true, text: 'All currencies' }}
          value={props.currency}
          onChange={props.onChangeCurrency}
        />
      </div>
    </div>
  );
};
